import { useCurrencyContext } from '@apeiron/currency'
import { DETAIL_USD_OPTIONS, DETAIL_WETH_OPTIONS } from '@apeiron/temp'
import { Box, styled } from '@mui/material'
import EthereumSVG from '@public/icons/icon-ethereum.svg'
import PriceText from '@src/components/share/generic/PriceText'
import * as R from 'ramda'
import { FC } from 'react'

const Container = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
`

const SellPriceText = styled(PriceText)`
  .Custom-Icon {
    ${props => props.theme.breakpoints.up('res480')} {
      width: 26px;
      height: 26px;
    }
    ${props => props.theme.breakpoints.down('res480')} {
      width: 24px;
      height: 24px;
    }
  }
  .Custom-Text {
    color: #ffffff;
    ${props => props.theme.breakpoints.up('res480')} {
      font-size: 32px;
      line-height: 38px;
    }
    ${props => props.theme.breakpoints.down('res480')} {
      font-size: 30px;
      line-height: 36px;
    }
  }
`

const ConversionPriceText = styled(PriceText)`
  margin-right: 2px;
  .Custom-Text {
    color: #b1b3b3;
    ${props => props.theme.breakpoints.up('res480')} {
      font-size: 16px;
      line-height: 18px;
    }
    ${props => props.theme.breakpoints.down('res480')} {
      font-size: 14px;
      line-height: 16px;
    }
  }
`

const TradePrice: FC<TradePriceProps> = (props: TradePriceProps) => {
  const { className, price, priceFiat } = props

  const { getApeironPrice } = useCurrencyContext()

  const formattedEthPrice = getApeironPrice(null, price, DETAIL_WETH_OPTIONS)

  const formattedPriceFiat = getApeironPrice(
    null,
    priceFiat,
    DETAIL_USD_OPTIONS
  )

  return (
    <Container className={className}>
      <SellPriceText icon={EthereumSVG} displayPrice={formattedEthPrice} />
      {!R.isNil(priceFiat) && (
        <ConversionPriceText prefix='~$ ' displayPrice={formattedPriceFiat} />
      )}
    </Container>
  )
}

export type TradePriceProps = {
  className?: string
  price: number
  priceFiat?: number
}

export default TradePrice
